import React from "react";
import "./Home1.css";
const Home1 = () => {
  return (
    <div className="home1-body">
      {/* <img src="https://firebasestorage.googleapis.com/v0/b/loftydreams-307f2.appspot.com/o/React-Images%2FUntitled%20design.svg?alt=media&token=b6819912-f6fa-4f94-8bc3-303a81382c63" alt="" className="home1-banner"/> */}
      <div className="home1-left">
        <h4 className="home1-heading">RECLINER MANUFACTURERS</h4>
        <p className="home1-p">
          Lofty Dreams Pvt. Ltd is a trust worthy leading recliner manufacturers
          and suppliers in India, dedicated to developing comfortable and
          durable furniture. The company’s aim is to provide optimum level of
          comfort, quality, luxurious {"&"} durable recliner chairs {"&"} sofas
          to our customer. When manufacturing recliners, we start work with
          consumer satisfaction in mind and attain more than the expectations.
          The company believes in setting up and keeping up a connection with
          each customer and wishes to bring seating comfort more {"&"}more homes
          in India.
        </p>
      </div>
      <div className="home1-right">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/loftydreams-307f2.appspot.com/o/Manual%20Recliners%2FCatPagePhoto%2FRecliners-Manufacturer-by-Lofty-Dreams-Recliners-Pvt.-Ltd..jpg?alt=media&token=550900a1-3f90-4d84-8d7b-6e2a2897efdckr"
          alt="home1"
        />
      </div>
    </div>
  );
};

export default Home1;
